import React from "react";

const Settings = () => {
  return (
    <section className="py-5" style={{ background: "#f4fff4" }}>
      <div className="container">
        <div className="card shadow-lg border-0 rounded-4 p-4">
          <h3 className="fw-bold text-success mb-4">Settings</h3>
          <ul className="list-group list-group-flush">
            <li className="list-group-item d-flex justify-content-between align-items-center">
              Notifications
              <div className="form-check form-switch">
                <input className="form-check-input" type="checkbox" defaultChecked />
              </div>
            </li>
            <li className="list-group-item d-flex justify-content-between align-items-center">
              Dark Mode
              <div className="form-check form-switch">
                <input className="form-check-input" type="checkbox" />
              </div>
            </li>
            <li className="list-group-item d-flex justify-content-between align-items-center">
              Email Alerts
              <div className="form-check form-switch">
                <input className="form-check-input" type="checkbox" defaultChecked />
              </div>
            </li>
            <li className="list-group-item d-flex justify-content-between align-items-center">
              Payment Methods
              <a href="/" className="btn btn-sm btn-outline-success">Manage</a>
            </li>
          </ul>
          <div className="mt-4 text-end">
            <button className="btn btn-danger px-4">Logout</button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Settings;
